/**
 * Enum representing different grouped error codes.
 */
export enum GroupedErrorCodeModel {
	/**
	 * A required field is missing.
	 */
	RequiredField = 1,
	/**
	 * A required field has an incorrect format.
	 */
	RequiredFormat = 2,
	/**
	 * A non-required field has an incorrect format.
	 */
	NonRequiredFormat = 3,
	/**
	 * An error related to J-Code format.
	 */
	JCodeFormat = 4,
	/**
	 * The resident's name format is incorrect.
	 */
	ResidentNameFormat = 5,
	/**
	 * The prescriber's DEA number format is incorrect.
	 */
	PrescriberDeaFormat = 6,
	/**
	 * The provided ICD-10 code is invalid.
	 */
	InvalidICD10 = 7,
	/**
	 * The patient's name does not match expected values.
	 */
	NonPatientName = 8,
	/**
	 * The submitted date is invalid.
	 */
	InvalidDateSubmitted = 9,
	/**
	 * The filled date does not match the customer's allowed range.
	 */
	CustomerDateFilledRange = 10,
	/**
	 * The filled date does not match the NCPDP allowed range.
	 */
	NcpdpDateFilledRange = 11,
	/**
	 * The filled date does not match the submission's allowed range.
	 */
	SubmissionDateFilledRange = 12,
	/**
	 * The submitted date does not match the customer's allowed range.
	 */
	CustomerDateSubmittedRange = 13,
	/**
	 * The processed date is invalid or outside the allowable range.
	 */
	InvalidProcessedDate = 14,
	/**
	 * The member's end date is earlier than the member's start date.
	 */
	MemberDateRange = 15,
	/**
	 * The provided place of service code is not valid.
	 */
	InvalidPlaceOfServiceCode = 16
}
